export enum UserStatusEnum {
    ACTIVE='ACTIVE',
    WITHOUT_ACCESS='WITHOUT_ACCESS',
    PASSWORD_RESET='PASSWORD_RESET',
    BLOCKED='BLOCKED'
}
